// extracted by mini-css-extract-plugin
var _1 = "Uh8kjU_Imdaa7NLswilY";
var _2 = "RyVAjkeavEAI9SiZ0zM2";
var _3 = "MjcY_7EzJExLCpyKV_ZV";
var _4 = "oEXyyQfAXh6GtmknJTWQ";
var _5 = "DdPLHnVxPPkdYN6gfilj";
export { _1 as "attachment", _2 as "image", _3 as "intro", _4 as "species", _5 as "title" }
